/* eslint-disable max-len */
/**
 * Awvent - OpenAIConnector API
 * Awvent OpenAIConnector Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpParams,
    HttpResponse,
    HttpEvent,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

import { AgentType } from '../model/agentType';
import { ThreadCreateCommand } from '../model/threadCreateCommand';
import { ThreadDtoListWebApiPagedResponse } from '../model/threadDtoListWebApiPagedResponse';
import { ThreadDtoWebApiResponse } from '../model/threadDtoWebApiResponse';
import { ThreadUpdateCommand } from '../model/threadUpdateCommand';
import { BooleanWebApiResponse } from '../../../common/models/booleanWebApiResponse';

import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH } from '../../../../variables';
import { ThreadDtoIListWebApiPagedResponse } from '../model/models';

@Injectable()
export class ThreadService {
    protected basePath = environment.api.openaiConnector;

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: Configuration
    ) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public threadActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public threadActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public threadActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public threadActivateIdPut(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling threadActivateIdPut.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling threadActivateIdPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'put',
            `${this.basePath}/Thread/Activate/${encodeURIComponent(
                String(id)
            )}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public threadDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public threadDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public threadDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public threadDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling threadDeactivateIdPut.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling threadDeactivateIdPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'put',
            `${this.basePath}/Thread/Deactivate/${encodeURIComponent(
                String(id)
            )}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param isActive
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public threadGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoIListWebApiPagedResponse>;
    public threadGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoIListWebApiPagedResponse>>;
    public threadGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoIListWebApiPagedResponse>>;
    public threadGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling threadGet.'
            );
        }

        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', <any>isActive);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append(
                    'OrderBy',
                    <any>element
                );
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set(
                'IsOrderByDescending',
                <any>isOrderByDescending
            );
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set(
                'SearchText',
                <any>searchText
            );
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set(
                'PageNumber',
                <any>pageNumber
            );
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<ThreadDtoIListWebApiPagedResponse>(
            'get',
            `${this.basePath}/Thread`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param threadType
     * @param businessAccountId
     * @param productId
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public threadGetSingleGet(
        xTenantId: string,
        threadType?: AgentType,
        businessAccountId?: string,
        productId?: string,
        id?: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public threadGetSingleGet(
        xTenantId: string,
        threadType?: AgentType,
        businessAccountId?: string,
        productId?: string,
        id?: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public threadGetSingleGet(
        xTenantId: string,
        threadType?: AgentType,
        businessAccountId?: string,
        productId?: string,
        id?: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public threadGetSingleGet(
        xTenantId: string,
        threadType?: AgentType,
        businessAccountId?: string,
        productId?: string,
        id?: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling threadGetSingleGet.'
            );
        }

        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (threadType !== undefined && threadType !== null) {
            queryParameters = queryParameters.set(
                'ThreadType',
                <any>threadType
            );
        }
        if (businessAccountId !== undefined && businessAccountId !== null) {
            queryParameters = queryParameters.set(
                'BusinessAccountId',
                <any>businessAccountId
            );
        }
        if (productId !== undefined && productId !== null) {
            queryParameters = queryParameters.set('ProductId', <any>productId);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'get',
            `${this.basePath}/Thread/GetSingle`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public threadIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<BooleanWebApiResponse>;
    public threadIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<BooleanWebApiResponse>>;
    public threadIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<BooleanWebApiResponse>>;
    public threadIdDelete(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling threadIdDelete.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling threadIdDelete.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<BooleanWebApiResponse>(
            'delete',
            `${this.basePath}/Thread/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public threadPost(
        xTenantId: string,
        body?: ThreadCreateCommand,
        xRequestId?: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public threadPost(
        xTenantId: string,
        body?: ThreadCreateCommand,
        xRequestId?: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public threadPost(
        xTenantId: string,
        body?: ThreadCreateCommand,
        xRequestId?: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public threadPost(
        xTenantId: string,
        body?: ThreadCreateCommand,
        xRequestId?: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling threadPost.'
            );
        }

        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'post',
            `${this.basePath}/Thread`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public threadPut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public threadPut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public threadPut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public threadPut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling threadPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'put',
            `${this.basePath}/Thread`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
}
